export const sessionStorageKeys = {
    userObjKey: 'usr',
    jwtTokenKey: 'jwtToken',
    citiesKey: 'cities',
    countryKey: 'country'
};
